import { render, staticRenderFns } from "./AllNotifications.vue?vue&type=template&id=0912eee8&scoped=true&"
import script from "./AllNotifications.vue?vue&type=script&lang=js&"
export * from "./AllNotifications.vue?vue&type=script&lang=js&"
import style0 from "./AllNotifications.vue?vue&type=style&index=0&id=0912eee8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0912eee8",
  null
  
)

export default component.exports